export const WidgetDataColour = {
  Green: 'var(--green-40)',
  Red: 'var(--red-60)',
};
